export const EXPRESS_DELIVERY_STORAGE_KEY = "sparepe_express_delivery";

export function readExpressFromUrl(search = "") {
  const params = new URLSearchParams(search);
  return params.get("express") === "1";
}

export function readSearchQueryFromUrl(search = "") {
  return new URLSearchParams(search).get("q") || "";
}

export function readExpressPreference(search = "") {
  if (readExpressFromUrl(search)) return true;
  try {
    return localStorage.getItem(EXPRESS_DELIVERY_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function persistExpressPreference(enabled) {
  try {
    if (enabled) {
      localStorage.setItem(EXPRESS_DELIVERY_STORAGE_KEY, "1");
    } else {
      localStorage.removeItem(EXPRESS_DELIVERY_STORAGE_KEY);
    }
  } catch {
    // Ignore storage errors (private browsing or quota).
  }
}

export function buildCatalogSearchParams({
  query = "",
  express = false,
  coords = null,
  radiusKm = 100,
  existingSearch = "",
} = {}) {
  const params = new URLSearchParams(existingSearch);
  const q = String(query || "").trim();
  if (q) params.set("q", q);
  else params.delete("q");

  if (express) {
    params.set("express", "1");
    if (coords?.lat != null && coords?.lng != null) {
      params.set("lat", String(coords.lat));
      params.set("lng", String(coords.lng));
      params.set("radiusKm", String(radiusKm));
    }
  } else {
    params.delete("express");
    params.delete("lat");
    params.delete("lng");
    params.delete("radiusKm");
  }

  return params;
}
